var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockIcon = function SvgClockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_523_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.06 12.12H11.41",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.01 2.51001C10.8281 2.51001 9.65779 2.7428 8.56586 3.19509C7.47393 3.64739 6.48178 4.31032 5.64605 5.14605C4.81032 5.98178 4.14739 6.97393 3.69509 8.06586C3.2428 9.15779 3.01001 10.3281 3.01001 11.51C3.01001 12.6919 3.2428 13.8622 3.69509 14.9542C4.14739 16.0461 4.81032 17.0382 5.64605 17.874C6.48178 18.7097 7.47393 19.3726 8.56586 19.8249C9.65779 20.2772 10.8281 20.51 12.01 20.51C14.397 20.51 16.6861 19.5618 18.374 17.874C20.0618 16.1861 21.01 13.897 21.01 11.51C21.01 9.12306 20.0618 6.83388 18.374 5.14605C16.6861 3.45822 14.397 2.51001 12.01 2.51001V2.51001Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.41 12.12V6.52002",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_523_182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgClockIcon as ReactComponent };
export default __webpack_public_path__ + "clock-icon.svg";